import { ApiResponse } from "@/models/api.model";
import { AxiosError } from "axios";
import { ActionTree } from "vuex";
import { RootState } from ".";
import cityApi from "../api/city.api";
import usersApi from "../api/users.api";
import i18n from "../i18n";
import { ToastMessage } from "./../models/toast-message.model";
import { RootMutationTypes } from "./root-mutations";
import * as Sentry from "@/utils/logger.util";

export const RootActionTypes = {
  HandleApiError: "HANDLE_API_ERROR",
  ShowToastMessage: "DISPLAY_TOAST_MESSAGE",
  FetchCities: "FETCH_CITIES",
  FetchUser: "FETCH_USERS"
};

export const actions: ActionTree<RootState, RootState> = {
  [RootActionTypes.HandleApiError]({ commit }, error: AxiosError<ApiResponse<any>>) {
    Sentry.captureException(error);

    if (error && error.response && error.response.data) {
      const { error_message } = error.response.data;
      if (error_message && typeof error_message === "object") {
        const toastMessages = Object.values(error_message as { [key: string]: string[] })
          .map<ToastMessage[]>(error =>
            error.map<ToastMessage>(errorMessage => ({
              title: i18n.tc("incorrect_data"),
              content: errorMessage,
              variant: "danger"
            }))
          )
          .flat(1);

        commit(RootMutationTypes.SetToastMessages, toastMessages);
      } else if (error_message) {
        const toastMessage = {
          title: i18n.tc("incorrect_data"),
          content: error_message,
          variant: "danger"
        };
        commit(RootMutationTypes.SetToastMessages, toastMessage);
      }
    }
  },
  async [RootActionTypes.ShowToastMessage]({ commit, dispatch }, message: ToastMessage) {
    commit(RootMutationTypes.SetToastMessages, message);
  },
  async [RootActionTypes.FetchCities]({ commit, dispatch }) {
    try {
      const response = await cityApi.getCities();
      commit(RootMutationTypes.SetCities, response.data.data);
    } catch (error) {
      Sentry.captureException(error);
      dispatch(RootActionTypes.HandleApiError, error, { root: true });
    }
  },
  async [RootActionTypes.FetchUser]({ commit, dispatch }, search: string) {
    commit(RootMutationTypes.SetUsersSearch, search);
    try {
      const response = await usersApi.getUsers(search);
      commit(RootMutationTypes.SetUsers, response.data.data);
    } catch (error) {
      Sentry.captureException(error);
      dispatch(RootActionTypes.HandleApiError, error, { root: true });
    }
  }
};
